import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-error",
  "use": "icon-error-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-error\"><defs><style type=\"text/css\"></style></defs><path d=\"M768 128l128 128-256 256 256 256-128 128-256-256-256 256-128-128 256-256-256-256 128-128 256 256 256-256z\" fill=\"#d81e06\" p-id=\"4998\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol